export const PoiIcons = [
  {
    image: require("@Assets/images/poi_heart.png"),
    name: "poi-favorite",
  },
];
